module.exports = __webpack_public_path__ + "images/stickers/pete-vacation.a71c97b1606f4afe6485.png";